import './TooltipDeliveryNoteShipToContent.css'

export const TooltipDeliveryNoteShipToContent = ({ data }) => {
  const shipTo = data.deliveryNote.fulfillmentRequestHeader.fulfillmentRequestParty?.find(
    (p) => p.partyTypeCode === 'SHIP_TO'
  )

  const shipmentShipToAddress = shipTo?.fulfillmentRequestLocationAddress
  const contact = shipTo?.fulfillmentRequestContact

  return (
    <table className="tooltip-shipto-content">
      <thead>
        <th colSpan={2}>
          <td>Ship To Details</td>
        </th>
      </thead>
      <tbody>
        {shipTo?.partyName2 && (
          <tr>
            <td>Ship To Name 2</td>
            <td>{shipTo?.partyName2}</td>
          </tr>
        )}
        {shipmentShipToAddress?.addressLine1Text && (
          <tr>
            <td>Address</td>
            <td>
              {`${shipmentShipToAddress?.addressLine1Text ?? ''} ${
                shipmentShipToAddress?.addressLine2Text ?? ''
              } ${shipmentShipToAddress?.addressLine3Text ?? ''} ${
                shipmentShipToAddress?.addressLine4Text ?? ''
              } ${shipmentShipToAddress?.addressLine5Text ?? ''}`}
            </td>
          </tr>
        )}
        {shipmentShipToAddress?.cityName && (
          <tr>
            <td>City Name</td>
            <td>{shipmentShipToAddress?.cityName}</td>
          </tr>
        )}
        {shipmentShipToAddress?.postalCode && (
          <tr>
            <td>Zip Code</td>
            <td>{shipmentShipToAddress?.postalCode}</td>
          </tr>
        )}
        {shipmentShipToAddress?.stateProvinceCode && (
          <tr>
            <td>Province State Region Code</td>
            <td>{shipmentShipToAddress?.stateProvinceCode}</td>
          </tr>
        )}
        {shipmentShipToAddress?.countryCode && (
          <tr>
            <td>Ship To Country</td>
            <td>{shipmentShipToAddress?.countryCode}</td>
          </tr>
        )}
        {shipmentShipToAddress?.languageCode && (
          <tr>
            <td>Language Code</td>
            <td>{shipmentShipToAddress?.languageCode}</td>
          </tr>
        )}
        {contact?.emailAddressText && (
          <tr>
            <td>Email Address</td>
            <td>{contact?.emailAddressText}</td>
          </tr>
        )}
        {contact?.dayPhoneNumber && (
          <tr>
            <td>Phone Number</td>
            <td>{contact?.dayPhoneNumber}</td>
          </tr>
        )}
      </tbody>
    </table>
  )
}

export default TooltipDeliveryNoteShipToContent
